import { FC } from 'react';
import ArrowTipDownIcon from '@stripcash/ui-kit/icons/arrowTipDown.svg';
import cn from 'classnames';

import s from './styles.module.css';

type CallRateLineProps = {
  isOpen: boolean;
  onClick: () => void;
};

const CallSurveyLine: FC<CallRateLineProps> = ({ onClick, isOpen }) => (
  <button
    type="button"
    onClick={onClick}
    className={cn(s.callLine, { [s.callLineClose]: isOpen })}
  >
    <div className={s.callLineIcon}>
      <ArrowTipDownIcon size={12} color="white" />
    </div>
  </button>
);

export default CallSurveyLine;
